// Utility to generate default note text for resume revisions
export function getFlexNoteDefaults(
  meetingViaCalendly,
  revisionNumber,
  coachName,
  candidateName,
  currentResumeReview,
  isFinalRevision,
  t,
) {
  const prefix = candidateName
    ? t('getFlexNoteDefaults.greeting', { candidateName })
    : ''
  const suffix = coachName
    ? t('getFlexNoteDefaults.coach_signature', { coachName })
    : ''

  if (isFinalRevision) {
    return prefix + t('getFlexNoteDefaults.finalRevision') + suffix
  }

  if (
    meetingViaCalendly === undefined &&
    !currentResumeReview?.revisionDeclined
  ) {
    if (currentResumeReview?.meetingViaCalendly === true) {
      return (
        prefix + t('getFlexNoteDefaults.firstRevision.meeting_based') + suffix
      )
    } else {
      return prefix + t('getFlexNoteDefaults.firstRevision.platform') + suffix
    }
  } else if (meetingViaCalendly) {
    if (
      revisionNumber == 2 ||
      (revisionNumber == 1 && currentResumeReview?.revisionDeclined)
    ) {
      return prefix + t('getFlexNoteDefaults.thirdRevision.declined') + suffix
    } else {
      return prefix + t('getFlexNoteDefaults.thirdRevision.completed') + suffix
    }
  } else {
    if (revisionNumber == 1 && currentResumeReview?.revisionDeclined) {
      return prefix + t('getFlexNoteDefaults.secondRevision.declined') + suffix
    } else {
      return prefix + t('getFlexNoteDefaults.secondRevision.completed') + suffix
    }
  }
}
